/** URL base del frontend (Redplika). En build: REACT_APP_FRONTEND_URL */
const frontendBase = (process.env.REACT_APP_FRONTEND_URL || window.location.origin).replace(/\/$/, '');

export const APP_URLS = {
  registroAfiliadoEpayco: `${frontendBase}/registro-afiliado-epayco`,
  registroPacientePremium: `${frontendBase}/registro-paciente-premium`,
  resultadoCursoEpayco: `${frontendBase}/resultado-curso-epayco`,
  resultadoCitaEpayco: `${frontendBase}/resultado-cita-epayco`,
  resultadoUpgradeEpayco: `${frontendBase}/resultado-upgrade-epayco`,
  aprobacionCitaEpayco: (role) => `${frontendBase}/${role}/aprobacion-cita-epayco`,
  passToMemberRegistro: (service) => `${frontendBase}/patient/miembro/${service}/registro`,
};

export default frontendBase;
